// Generated types for CalculationState
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from '../../shared/types/neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from '../../shared/types/neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface CalculationStateReadAPI extends NeoNodeReadAPI {
  holder: string;
  lane: string;
  expression_id: string;
}

export interface CalculationStateWriteAPI extends NeoNodeWriteAPI {
  holder: string;
  lane: string;
  expression_id: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const CalculationStateReadAPISchema: z.ZodType<CalculationStateReadAPI> = NeoNodeReadAPISchemaObject.extend({
  holder: z.string(),
  lane: z.string(),
  expression_id: z.string(),
}).passthrough();

export const CalculationStateWriteAPISchema: z.ZodType<CalculationStateWriteAPI> = NeoNodeWriteAPISchemaObject.extend({
  holder: z.string(),
  lane: z.string(),
  expression_id: z.string(),
}).passthrough();
